/**
 * Enum for email notify from types.
 * @readonly
 * @enum {String} EmailNotifyFromEnum
 */

const EmailNotifyFromEnum = {
  ORDER  : 'order',
  TABLE  : 'table',
  RECEIPT: 'receipts'
}

export default EmailNotifyFromEnum
